import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import api from "../../api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { loadOrders } from "../../store/order.store"
import Header from "../Layout/Header"
import IncomingOrdersTable from "./IncomingOrdersTable"

const Consolidations = () => {
    //Date Picker Logic
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { orders, total, loading, error, success } = useAppSelector((state: RootState) => state.orders)
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const [errors, setErrors] = useState({} as Record<string, any>)
    const [selectedParcels, setSelectedParcels] = useState([] as number[])
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [optionsForListing, setOptionsForListing] = useState({
        page: 1,
        size: 250
    })
    const [reqLoading, setReqLoading] = useState(false)
    const [keyword, setKeyword] = useState("")
    const [toast, setToast] = useState({} as Record<string, any>)
    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    const loadList = () => {
        dispatch(
            loadOrders({
                warehouse: (selectedWarehouse || defaultWarehouse)?.toString(),
                page: optionsForListing?.page,
                size: optionsForListing?.size,
                keyword
            })
        )
    }

    const regenerateLabels = async (listId: number) => {
        try {
            setReqLoading(true)
            let { data } = await api.parcel.regenerateLabels({ list_id: listId, parcels_ids: selectedParcels })
            if (data.status) {
                setToast({ msg: "Labels Regenerated Successfully", severity: "success" })
                // setTimeout(() => {
                loadList()
                // }, 3000)
            } else {
                setToast({ msg: "Something Went Wrong", severity: "danger" })
            }
            setSelectedParcels([])
            setReqLoading(false)
        } catch (error) {
            setToast({ msg: "Something Went Wrong", severity: "danger" })
            console.log(error)
            setReqLoading(false)
        }
    }

    useEffect(() => {
        loadList()
    }, [selectedWarehouse, JSON.stringify(optionsForListing)])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="incomingOrders">
                    <Header
                        title="Incoming Orders"
                        records={Object.keys(orders)?.length + orders?.map((o) => o.parcels)?.length}
                        data={orders}
                        name="incomingOrders"
                        //buttonId="#consolidationExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                            />*/}
                        </div>
                    </Header>

                    <div className="row  d-flex tabs-data px-2">
                        <IncomingOrdersTable
                            orders={orders}
                            page={optionsForListing?.page}
                            size={optionsForListing?.size}
                            keyword={keyword}
                            setKeyword={setKeyword}
                            onSearch={loadList}
                            setOptionsForListing={setOptionsForListing}
                            total={total}
                            selectedParcels={selectedParcels}
                            setSelectedParcels={setSelectedParcels}
                            regenerateLabels={regenerateLabels}
                            toast={toast}
                            setToast={setToast}
                            reqLoading={reqLoading}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default Consolidations
